module.exports = __webpack_public_path__ + "376a71f9948e34a60b2f67c9773d5780.MP3";